'kiwi public';

import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import { escape } from 'lodash';
import getState from '@/libs/state';
import * as EmojiProvider from '@/libs/EmojiProvider';
export default render;
function render(blocks, renderEmoticons) {
  var state = getState();
  var showEmoticons = typeof renderEmoticons === 'undefined' ? state.setting('buffers.show_emoticons') : !!renderEmoticons;
  var retHtml = blocks.reduce(function (html, block, i) {
    // a
    var style = '';
    var classes = '';
    _Object$keys(block.styles).forEach(function (s) {
      if (s === 'underline') {
        style += 'text-decoration:underline;';
      } else if (s === 'bold') {
        style += 'font-weight:bold;';
      } else if (s === 'italic') {
        style += 'font-style:italic;';
      } else if (s === 'quote') {
        classes += 'kiwi-formatting-extras-quote ';
      } else if (s === 'block') {
        classes += 'kiwi-formatting-extras-block ';
      } else if (s === 'color') {
        classes += "irc-fg-colour-".concat(block.styles[s], " ");
      } else if (s === 'background') {
        classes += "irc-bg-colour-".concat(block.styles[s], " ");
      }
    });
    var content;
    switch (block.type) {
      case 'url':
        content = linkifyUrl(block, {
          addHandle: state.setting('buffers.show_link_previews'),
          handleClass: 'fa fa-share-square u-link kiwi-messagelist-message-linkhandle'
        });
        break;
      case 'user':
        content = linkifyUser(block);
        break;
      case 'channel':
        content = linkifyChannel(block);
        break;
      case 'emoji':
        content = EmojiProvider.blockToHtml(block, blocks.length === 1, showEmoticons);
        break;
      default:
        content = escape(block.content);
    }
    return html + buildSpan(content, classes, style);
  }, '');
  return "".concat(retHtml);
}
function linkifyUrl(block, _opts) {
  var _context;
  var opts = _opts || {};
  var nice = '';

  // Shorten the displayed URL if it's going to be too long
  if (block.content.length > 100) {
    nice = escape(block.content.substr(0, 100)) + '...';
  } else {
    nice = escape(block.content);
  }

  // Make the link clickable
  var href = block.meta.url.replace(/"/g, '%22');
  var out = _concatInstanceProperty(_context = "<a target=\"_blank\" href=\"".concat(href, "\" rel=\"noopener noreferrer\" class=\"u-link\">")).call(_context, nice, "</a>");
  if (opts.addHandle) {
    var _context2, _context3;
    var cssClass = opts.handleClass || '';
    var content = opts.handleContent || '';
    out += _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "<a data-url=\"".concat(escape(block.meta.url), "\" class=\"")).call(_context3, cssClass, "\">")).call(_context2, content, "</a>");
  }
  return out;
}
function linkifyUser(block) {
  var escaped = escape(block.meta.user);
  var colour = block.meta.colour;
  return "<a class=\"kiwi-nick\" data-nick=\"".concat(escaped, "\"") + (colour ? " style=\"color:".concat(colour, ";\"") : '') + ">".concat(escaped, "</a>");
}
function linkifyChannel(block) {
  var _context4;
  return _concatInstanceProperty(_context4 = "<a class=\"u-link kiwi-channel\" data-channel-name=\"".concat(escape(block.meta.channel), "\">")).call(_context4, escape(block.content), "</a>");
}
function buildSpan(content, classes, style) {
  if (style === '' && classes === '') {
    return content;
  }
  return '<span' + (style !== '' ? " style=\"".concat(style, "\"") : '') + (classes !== '' ? " class=\"".concat(classes, "\"") : '') + ">".concat(content, "</span>");
}
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["libs"]) window._kiwi_exports["libs"] = {};
if(!window._kiwi_exports["libs"]["renderers"]) window._kiwi_exports["libs"]["renderers"] = {};
window._kiwi_exports["libs"]["renderers"]["Html"]
window._kiwi_exports.libs.renderers.Html = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
